import approvalReducers from "./reducers";
import permitActions from "./actions";
export { default as approvalActionTypes } from "./action-types";
export { default as permitActions } from "./actions";
export { default as approvalMiddleware } from "./middlewares";
export {};
export default approvalReducers;

export type IApprovalActions = typeof permitActions;
